import { Modal } from 'bootstrap'

function modalShow(identifier: string) {
  let element = document.getElementById(identifier)
  if (!element) return

  cleanupModalResiduals()

  let modal = Modal.getOrCreateInstance(element)
  modal.show()
}

function cleanupModalResiduals() {
  if (!document.querySelector('.modal.show')) {
    document.body.classList.remove('modal-open')
    document.body.style.removeProperty('overflow')
    document.body.style.removeProperty('padding-right')
  }
  document.querySelectorAll('.modal-backdrop').forEach((backdrop) => {
    if (!document.querySelector('.modal.show')) {
      backdrop.remove()
    }
  })
}

function modalHide(identifier: string) {
  let element = document.getElementById(identifier)
  if (!element) {
    cleanupModalResiduals()
    return
  }

  let modal = Modal.getInstance(element)
  if (!modal) {
    cleanupModalResiduals()
    return
  }

  element.addEventListener('hidden.bs.modal', () => {
    cleanupModalResiduals()
  }, { once: true })

  modal.hide()
}

export { modalShow, modalHide }
